import React, { useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import {
  ReactRequiredChildren,
  ReactComponentStaticProps,
} from "../../types/react";

import { useGroup } from "./GroupContext";
import { useCollapse } from "./CollapseContext";
import { useTable } from "./TableContext";

import styles from "./ComparisonTable.scss";

type ComparisonTableRowHeaderBaseProps = {
  id: string;
};

export type ComparisonTableRowHeaderProps = ComparisonTableRowHeaderBaseProps &
  Omit<
    ReactRequiredChildren<React.ComponentPropsWithoutRef<"tr">>,
    keyof ComparisonTableRowHeaderBaseProps
  >;

export const ComparisonTableRowHeader: ((
  props: ComparisonTableRowHeaderProps
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableRowHeaderProps> = ({
  children,
  id,
  ...restProps
}) => {
  const { setHeaderRowId } = useGroup();
  const { collapseRows } = useCollapse();
  const { hasColumnHeader, headerColumnIds } = useTable();

  useEffect(() => {
    setHeaderRowId(id);
  }, [id]);
  const columnCount = (hasColumnHeader ? 1 : 0) + headerColumnIds.length;
  return (
    <tr
      className={cx(styles["row-header"], {
        [styles["collapse-until-l"]]: collapseRows,
      })}
      {...restProps}
    >
      <th scope="colgroup" colSpan={columnCount} id={id}>
        <span className={styles.fixed}>{children}</span>
      </th>
    </tr>
  );
};

ComparisonTableRowHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  id: PropTypes.string.isRequired,
};

ComparisonTableRowHeader.displayName = "ComparisonTable.RowHeader";

export default ComparisonTableRowHeader;
